import React, { useEffect, useState } from 'react'
import { Responsive, WidthProvider } from 'react-grid-layout'
import { Box, useTheme } from '@mui/material'

import './style.css'
import ValeurHoraire from './Component/Card/ValeurHoraire'
import TempsTravail from './Component/Card/TempsTravail'
import TempsFormation from './Component/Card/TempsFormation'
import SoftSkills from './Component/Card/SoftSkills'
import Opportunite from './Component/Card/Opportunite'
import Competences from './Component/Card/Competences'
import ProfilUtilisateur from './Component/Card/ProfilUtilisateur'
import Recommandation from './Component/Card/Recommandation'
import { makeGetRequest } from 'utils/api'
import { useLocation, useNavigate } from 'react-router-dom'
const ResponsiveGridLayout = WidthProvider(Responsive)

function SyntheseProfessionnelle() {
  const theme = useTheme()
  const location = useLocation()
  const navigate = useNavigate()
  const [reports, setReports] = useState([])
  const [openProfileFromUrl, setOpenProfileFromUrl] = useState(false)
  useEffect(() => {
    getSyntheseTempsReports()
  }, [])
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const urlAction = searchParams.get('action') || searchParams.get('modal')

    if (urlAction === 'complete-profile') {
      setOpenProfileFromUrl(true)
    }
  }, [location.search])
  const getSyntheseTempsReports = async () => {
    const { data } = await makeGetRequest('/api/Professional/getProfessionnelle/', {}, true)
    setReports([...data])
  }
  const layout1 = [
    { i: '1', x: 0, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '2', x: 3, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '3', x: 6, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '4', x: 9, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '5', x: 0, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '6', x: 3, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '7', x: 6, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '8', x: 9, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
  ]
  const layout2 = [
    { i: '1', x: 0, y: 0, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '2', x: 5, y: 0, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '3', x: 0, y: 0, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '4', x: 5, y: 0, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '5', x: 0, y: 5, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '6', x: 5, y: 5, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '7', x: 0, y: 5, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '8', x: 5, y: 5, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
  ]
  const layout3 = [
    { i: '1', x: 0, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '2', x: 3, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '3', x: 0, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '4', x: 3, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '5', x: 0, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '6', x: 3, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '7', x: 0, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '8', x: 3, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
  ]
  const layout4 = [
    { i: '1', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '2', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '3', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '4', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '5', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '6', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '7', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '8', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
  ]
  const layouts = { lg: layout1, md: layout2, sm: layout3, xs: layout4 }

  const children = React.useMemo(() => {
    const xArr = [0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9]
    return (
      reports &&
      reports.map((val, idx) => (
        <div
          key={idx}
          style={{ backgroundColor: theme.palette.appBar.main, display: 'grid' }}
          data-grid={{
            x: xArr[idx],
            y: Infinity,
            w: 3,
            h: 3,
            minW: 2,
            maxW: 8,
            minH: 3,
            maxH: 10,
          }}
        >
          {val.type === 'valeurhoraire' && (
            <ValeurHoraire updateReports={getSyntheseTempsReports} oldData={val.data} />
          )}
          {val.type === 'tempstravail' && (
            <TempsTravail updateReports={getSyntheseTempsReports} oldData={val.data} />
          )}
          {val.type === 'tempsformation' && (
            <TempsFormation updateReports={getSyntheseTempsReports} oldData={val.data} />
          )}
          {val.type === 'softskills' && (
            <SoftSkills updateReports={getSyntheseTempsReports} oldData={val.data} />
          )}
          {val.type === 'opportunite' && (
            <Opportunite updateReports={getSyntheseTempsReports} oldData={val.data} />
          )}
          {val.type === 'competences' && (
            <Competences updateReports={getSyntheseTempsReports} oldData={val.data} />
          )}
          {val.type === 'profilutilisateur' && (
            <ProfilUtilisateur
              updateReports={getSyntheseTempsReports}
              oldData={val.data}
              openFromUrl={openProfileFromUrl}
              onUrlOpenConsumed={() => {
                setOpenProfileFromUrl(false)
                navigate(location.pathname, { replace: true })
              }}
            />
          )}
          {val.type === 'recommandation' && (
            <Recommandation updateReports={getSyntheseTempsReports} oldData={val.data} />
          )}
        </div>
      ))
    )
  }, [reports])

  return (
    <Box maxWidth={1650} ml={'auto'} mr={'auto'}>
      <ResponsiveGridLayout
        className="layout"
        style={{ margin: '10px' }}
        autoSize={true}
        layouts={layouts}
        useCSSTransforms={true}
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
        draggableCancel=".no-drag"
      >
        {children}
      </ResponsiveGridLayout>
    </Box>
  )
}

export default SyntheseProfessionnelle
